__turbopack_context__.v({
  "fields": "JCxkkW_fields",
  "shimmer": "JCxkkW_shimmer",
  "text-bar-sweep": "JCxkkW_text-bar-sweep",
});
